import {Dom, Event} from 'main.core';

const EVENT_NAMESPACE = 'BX.Citrus.Aproduction3.Overlay';
export const SHOWN_EVENT = `shown`;
export const HIDDEN_EVENT = `hidden`;

let instance = undefined;

export class Overlay extends Event.EventEmitter
{
	constructor(options = {})
	{
	    super();
	    instance = this;
	    this.setEventNamespace(EVENT_NAMESPACE);

	    this.actor = this.isOpen = null;
	    this.body = document.body;
	    this.element = Dom.create('div', {
            attrs: {
                class: 'b-overlay',
            },
            events: {
	            click: () => this.hide(this.actor),
            }
	    });
	    Dom.append(this.element, this.body);
	}

	static getInstance() {
	    return instance || new Overlay();
    }

    show(actor) {
	    this.body.classList.add('_overflow');
        this.actor = actor;
        this.isOpen = true;
        this.emit('shown', new Event.BaseEvent({
            data: { actor },
        }));
    }

    hide(actor) {
	    if (!this.isOpen) {
	        return;
        }
        this.isOpen = false;
        this.body.classList.remove('_overflow');
        this.emit('hidden', new Event.BaseEvent({
            data: { actor: this.actor },
        }));
    }
}

